<template>
  <div class="wrapper">
    <div class="header">
      <el-form
        class="form-style"
        :model="form1"
        size="mini"
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item label="所属科目:" prop="subject_id">
          <el-select
            v-model="form1.subject_id"
            placeholder="请选择"
            clearable
            @change="search"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) of subjectList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题库来源:">
          <el-select
            v-model="form1.source_id"
            filterable
            placeholder="请选择"
            clearable
            @change="search"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="题库名称:" prop="title">
          <el-input
            style="width: 200px"
            v-model="form1.title"
            placeholder="请输入名称"
            clearable
            @keyup.enter.native="search"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            class="search_btn"
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="search"
            >查询</el-button
          >

          <el-button
            class="search_btn"
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="addproblem"
            >新增题库</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="question_wrapper">
      <el-table
        size="small"
        :data="questionlist"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#606266',
          'font-size': '14px',
        }"
        stripe
      >
        <el-table-column align="center" width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + (page_no - 1) * 20 }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="left"
          label="科目"
          prop="subjectName"
          width="80"
        >
        </el-table-column>

        <el-table-column align="left" label="题库名称">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="来源" prop="" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.sourceInfo != null">{{
              scope.row.sourceInfo.title
            }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="简介" prop="content" width="200">
        </el-table-column>

        <el-table-column
          align="left"
          width="150"
          label="创建人"
          prop="realname"
        >
        </el-table-column>

        <el-table-column align="center" label="题数" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.question_num }}</span>
          </template>
        </el-table-column>
        <!--
        <el-table-column align="left" label="排序号" prop="sort_num">
        </el-table-column>
        -->

        <el-table-column align="center" fixed="right" label="操作" width="240">
          <template slot-scope="scope">
            <el-button
              @click="CreatePractice(scope.row)"
              type="text"
              size="mini"
              class="wg-table-operation"
            >
              布置练习
            </el-button>
            <el-button
              @click="CreateExam(scope.row)"
              type="text"
              size="mini"
              class="wg-table-operation"
            >
              发起考试
            </el-button>
            <!-- <el-button
              @click="QuestionBank(scope.row)"
              type="text"
              size="mini"
              class="wg-table-operation"
              >编辑</el-button
            >
            <el-button
              @click.native="QuestionManagement(scope.row)"
              type="text"
              size="mini"
              class="wg-table-operation"
              >题目</el-button
            > -->

            <el-dropdown>
              <span class="el-dropdown-link wg-table-operation">
                更多
                <i class="el-icon-arrow-down"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item @click.native="goPay(scope.row)">报名课程</el-dropdown-item> -->

                <el-dropdown-item @click.native="QuestionManagement1(scope.row)"
                  >题库预览</el-dropdown-item
                >
                <el-dropdown-item @click.native="QuestionBank(scope.row)"
                  >编辑</el-dropdown-item
                >
                <el-dropdown-item @click.native="QuestionManagement(scope.row)"
                  >题目</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native="deleteSchoolQuestionBank(scope.row.id)"
                  >删除</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>

            <!--



            <el-link class="quest_btn" type="primary" @click="QuestionManagement1(scope.row)">题库预览</el-link>
            <el-link class="quest_btn" type="primary" @click="AddQuestion(scope.row)">添加试题</el-link>

            <el-link class="quest_btn" type="primary" @click="deleteSchoolQuestionBank(scope.row.id)">删除</el-link>

            <el-link v-if="scope.row.post_state == 2" class="quest_btn" type="primary" @click="changeSchoolQuestionBankPostState(scope.row.id, '1')">发布</el-link>
            <el-link v-else class="quest_btn" type="primary" @click="changeSchoolQuestionBankPostState(scope.row.id, '2')">停用</el-link>
     -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page_no"
        layout="total, prev, pager, next"
        :page-size="page_size"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog :title="dialog_title" :visible.sync="dialogVisible" width="40%">
      <el-form
        class="form-style"
        :model="form"
        size="mini"
        label-position="top"
      >
        <el-form-item label="序号" required>
          <el-input-number v-model="form.sort_num"></el-input-number>
        </el-form-item>
        <el-form-item label="所属科目" required>
          <el-select v-model="form.subject_id" placeholder="请选择" filterable>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in subjectList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="题库名称" required>
          <el-input
            v-model="form.title"
            placeholder="请输入名称"
            @input="$forceUpdate()"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 题库来源">
          <el-select
            v-model="form.source_id"
            filterable
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="简介" required>
          <el-input
            @input="$forceUpdate()"
            type="textarea"
            v-model="form.desc"
            placeholder="请输入题库的简介"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="封面">
          <el-upload action="" :http-request="uploadFile" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="1" :file-list="form.imgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
          

            <el-form-item label="封面" required>
              <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="1" :file-list="form.imgList" list-type="picture">
                <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
               
                <div slot="tip" class="el-upload__tip">
                  <span>推荐尺寸(750*340)</span>
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>

            -->
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="addOrUpdateSchoolQuestionBank"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addOrUpdateSchoolQuestionBank,
  getSchoolQuestionBankList,
  deleteSchoolQuestionBank,
  changeSchoolQuestionBankPostState,
  getTestQuestionBankSourceListWithoutP,
} from '@/api/educational'

import { getZoneSchoolSubjectList } from '@/api/community'

import uploadFileSchool from '@/config/uploadFileSchool'
export default {
  name: 'CommonExam-OwnQuestion',
  data() {
    return {
      options: [],
      subject_state: 1,
      uploadFileTime: false,
      dialog_title: '新增题库',

      questionlist: [],

      form: {
        source_id: '',
        id: '',
        sort_num: 1,
        title: '',
        subject_id: '',
        desc: '',
        img_url: '',
        imgList: [],
      },

      form1: {
        subject_id: '',
        title: '',
        source_id: '',
      },

      subjectList: [],
      dialogVisible: false, //新增题库
      input: '',
      page_no: 1,
      page_size: 20,
      total: 0,
    }
  },
  activated() {
    this.getSchoolQuestionBankList()
  },
  mounted() {
    this.getZoneSchoolSubjectList()
    this.getSchoolQuestionBankList()
    this.getTestQuestionBankSourceListWithoutP()
  },

  methods: {
    //来源列表
    getTestQuestionBankSourceListWithoutP() {
      getTestQuestionBankSourceListWithoutP().then((res) => {
        console.log(res, 95656)
        this.options = res.testQuestionBankSourceList
      })
    },
    addproblem() {
      this.dialogVisible = true
      this.form = {}
      this.form.sort_num = 1
    },
    QuestionManagement1(row) {
      console.log('试题管理')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-Questionlist1',
        query: {
          id: row.id,
          title: row.title,
          subject_id: row.subject_id,
        },
      })
    },
    //添加题库
    addOrUpdateSchoolQuestionBank() {
      if (this.form.id) {
        this.dialog_title = '修改题库'
        addOrUpdateSchoolQuestionBank({
          source_id: this.form.source_id,
          questionBankId: this.form.id,
          subject_id: this.form.subject_id,
          title: this.form.title,
          content: this.form.desc,
          sort_num: this.form.sort_num,
          // cover_url: this.form.imgList[0].url,
        }).then((res) => {
          console.log('更新成功')
          console.log(res)
          if (res.is_update) {
            this.$message.success('更新成功')
            this.dialogVisible = false
            this.getSchoolQuestionBankList()
          }
        })
      } else {
        this.dialog_title = '新增题库'
        addOrUpdateSchoolQuestionBank({
          source_id: this.form.source_id,
          subject_id: this.form.subject_id,
          title: this.form.title,
          content: this.form.desc,
          sort_num: this.form.sort_num,
          // cover_url: this.form.imgList[0] ? this.form.imgList[0].url : "",
        }).then((res) => {
          console.log('添加题库')
          console.log(res)
          if (res.is_created) {
            this.$message.success('添加成功')
            this.dialogVisible = false
            this.getSchoolQuestionBankList()
            this.form = {}
          }
        })
      }
    },

    search() {
      this.page_no = 1
      this.getSchoolQuestionBankList()
    },

    //查询题库
    getSchoolQuestionBankList() {
      getSchoolQuestionBankList({
        source_id: this.form1.source_id,
        subject_id: this.form1.subject_id,
        title: this.form1.title,
        search_question_bank_type: '2',
        post_state: '',
        isShowSelfPaper: 'false',
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询校区题库')
        console.log(res)
        this.questionlist = res.questionBankList
        this.total = res.total
      })
    },

    getZoneSchoolSubjectList() {
      getZoneSchoolSubjectList().then((res) => {
        console.log('校区科目')
        console.log(res)
        this.subjectList = res.subjectList
      })
    },

    //编辑题库
    QuestionBank(row) {
      console.log('编辑题库')
      console.log(row.sourceInfo, 45323)
      this.dialogVisible = true
      if (row.sourceInfo != undefined) {
        this.form.source_id = row.sourceInfo.id
      } else {
        this.form.source_id = ''
      }
      this.form.id = row.id
      this.form.sort_num = row.sort_num
      this.form.subject_id = row.subject_id
      this.form.title = row.title
      this.form.desc = row.content
      this.form.imgList = [
        {
          url: row.cover_url,
          name: row.cover_url.split('/')[row.cover_url.split('/').length - 1],
        },
      ]
    },

    deleteSchoolQuestionBank(id) {
      this.$confirm('确定删除该题库吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteSchoolQuestionBank({
          questionBankId: id,
        }).then((res) => {
          console.log('删除题库')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.getSchoolQuestionBankList()
          }
        })
      })
    },
    //发布状态
    changeSchoolQuestionBankPostState(id, cmd) {
      changeSchoolQuestionBankPostState({
        questionBankId: id,
        post_state: cmd,
      }).then((res) => {
        console.log('题库发布状态')
        console.log(res)

        this.getSchoolQuestionBankList()
      })
    },

    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.form.imgList = res
          this.uploadFileTime = false
        }
      )
    },

    //添加试题
    AddQuestion(row) {
      console.log('添加试题')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-AddQuestion',
        query: {
          id: row.id,
          title: row.title,
          subject_id: row.subject_id,
          question_num: row.question_num,
          tpye: '1',
        },
      })
    },
    QuestionManagement(row) {
      console.log('试题管理')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-Questionlist',
        query: {
          id: row.id,
          title: row.title,
          subject_id: row.subject_id,
          question_num: row.question_num,
        },
      })
    },
    Practice(row) {
      console.log('练习')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-Practice',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getSchoolQuestionBankList()
    },
    handleRemove() {},
    uploadFileSchool() {},
    CreatePractice(item) {
      console.log('创建练习', item)
      this.$router.push({
        name: 'CommonExam-CreatePractice',
        query: {
          id: item.id, // 题库ID
          // subject_id: item.subject_id, // 科目
          // bank_type: '1', // 类型 ''全部 '1'平台题库 '2'校区题库
          // source_id: item.source_id, // 题库来源
          // bank_name: item.title, // 题库名称
          papername: item.title,
          subject_id: item.subject_id, // 科目ID
        },
      })
    },
    CreateExam(item) {
      console.log('创建考试', item)
      this.$router.push({
        name: 'CommonExam-CreateExam',
        query: {
          papername: item.title, // 试卷名称+当前时间
          id: item.id, // 题库ID
          subject_id: item.subject_id, // 科目ID
          source_id: item.source_id, // 来源ID
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  box-sizing: border-box;
  min-height: 100%;
  margin: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-top: 5px;
  background: white;
  border-radius: 5px;

  .header {
    .search {
      width: 250px;
    }

    .search_btn {
      margin-left: 20px;
    }
  }

  .question_wrapper {
    .quest_btn {
      margin-left: 5px;
      margin-right: 5px;
    }
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
    padding-left: 10px;
  }
}
</style>
